import apiDB from './api_db';
import connect_api from '../connect/connect_api';
import store from '../store';
import notification from '../components/subcomponents/notification';

let calendar = new apiDB({
    api_module: 'calendar',
    table_key_name: 'id',
    reducer_name: 'calendarR',
    reducer_var: 'calendar',
    action_prefix: 'CALENDAR'
});

calendar.by_month = function (month, year, callback) {
    connect_api.sPOST('/calendar/by_month', { month, year }, function (error, response) {
        if (error) {
            notification.error(error.api_error ? error.api_error.message : 'Error');
            if (typeof callback === 'function') callback(error, false);
        } else {
            store.dispatch({ type: 'CALENDAR_BY_MONTH', data: response.api_data });
            if (typeof callback === 'function') callback(false, response.api_data);
        }
    });
};

calendar.next_closest = function (timestamp, callback) {
    connect_api.sPOST('/calendar/next_closest', { timestamp }, function (error, response) {
        if (error) {
            notification.error(error.api_error ? error.api_error.message : 'Error');
            if (typeof callback === 'function') callback(error, false);
        } else {
            if (typeof callback === 'function') callback(false, response.api_data);
        }
    });
};

calendar.users_list = function (callback) {
    connect_api.sPOST('/calendar/users_list', {}, function (error, response) {
        if (error) {
            if (typeof callback === 'function') callback(error, false);
        } else {
            store.dispatch({ type: 'CALENDAR_USERS_LIST', data: response.api_data });
            if (typeof callback === 'function') callback(false, response.api_data);
        }
    });
};

export default calendar;
